export const ActionOptions = {
  ALL: 'ALL'
};